import React from 'react';
import { Box, Typography, Stack, IconButton, Link } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';

const iconMap = {
  github: GitHubIcon,
  linkedin: LinkedInIcon,
  email: EmailIcon,
  scholar: SchoolOutlinedIcon,
};

const Contact = ({ email, social }) => (
  <Box
    id="contact"
    sx={{
      py: { xs: 4, md: 6 },
      maxWidth: { xs: '100%', md: 1200 },
      mx: 'auto',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
      <Box
        sx={{
          width: '4px',
          height: { xs: '24px', md: '32px' },
          bgcolor: 'primary.main',
          mr: 2,
        }}
      />
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: 24, md: 32 },
          fontWeight: 700,
          color: 'text.primary',
        }}
      >
        Contact
      </Typography>
    </Box>
    <Typography variant="body1" sx={{ fontSize: { xs: 16, md: 18 }, mb: 2, textAlign: 'center' }}>
      I'm always excited to connect with fellow researchers, potential collaborators, and industry partners. I’m currently on on the academic job market. So feel free to reach out at{' '}
      <Link 
        href="mailto:p.malekzadeh@rotman.utoronto.ca" 
        sx={{ 
          color: 'primary.main',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline'
          }
        }}
      >
        p.malekzadeh@rotman.utoronto.ca
      </Link>
      {' '}😊
    </Typography>
    <Stack direction="row" spacing={2} justifyContent="center">
      {social.map(({ icon, url }) => {
        const Icon = iconMap[icon];
        return (
          <IconButton
            color="primary"
            href={url}
            target="_blank"
            key={icon}
            size="large"
            sx={{ 
              '& .MuiSvgIcon-root': {
                fontSize: { xs: '1.5rem', sm: '1.8rem' }
              }
            }}
          >
            <Icon fontSize="inherit" />
          </IconButton>
        );
      })}
    </Stack>
  </Box>
);

export default Contact; 